module.exports = __webpack_public_path__ + "static/img/IMG_20170905_192206.bd32ae02.jpg";